import {useSnackbar} from 'notistack';
import {forwardRef, useImperativeHandle} from 'react';

import API from '../../../api/axios';
import {apiBaseUrl} from '../../../api/urls';
import {CloseSnackbarAction} from '../../common/CloseSnackbarButton';

export interface StandDownProps {
  onSubmitted?: () => void;
}

export interface StandDownRef {
  submit: (pk: number) => void;
}

export const AMSSensorItemStandDown = forwardRef<
  StandDownRef,
  React.PropsWithChildren<StandDownProps>
>(({onSubmitted}, ref) => {
  const {enqueueSnackbar} = useSnackbar();

  /*******/
  /* ref */
  /*******/
  useImperativeHandle(ref, () => ({
    submit: (pk) => submitData(pk),
  }));

  /**********/
  /* submit */
  /**********/
  const submitData = async (pk: number) => {
    try {
      const endpoint = `${apiBaseUrl}/ams/${pk}/stand_down`;
      const response = await API.patch(endpoint);
      const message =
        response?.data?.message ??
        'Stand down message has been sent successfully.';

      enqueueSnackbar(message, {
        variant: 'success',
        action: CloseSnackbarAction,
      });
      onSubmitted?.();
    } catch (error: any) {
      const message = error?.response?.data?.message ?? 'There is an error';
      enqueueSnackbar(message, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
  };

  return null;
});
